module.exports = __webpack_public_path__ + "bb50b4edcadcad3f6559ab87c1abfa0c.pdf";